import { Action } from '@reduxjs/toolkit';

import { ReduxAction } from 'app/redux/types';

export const BACKUP = 'PERSISTENCE:BACKUP';
export type Backup = Action<typeof BACKUP>;


export const RESTORE  = 'PERSISTENCE:RESTORE';
export type Restore<T> = ReduxAction<typeof RESTORE, T>;
